<template>
  <div class="request-home">
    <div class="video-container">
      <video id="video" autoplay loop muted>
        <source src="/dist/video/03_about.mp4" type="video/mp4">
        배경화면
      </video>
    </div>
    <div class="welcome-header"></div>
    <div class="welcome" style="z-index:2">
      <div class="box">
        <div class="box-content">
          <router-link to="/">
            <div class="ncp-logo">
            </div>
          </router-link>
          <p class="welcome-title1">QR 스캔</p>
          <br/>
          <br/>
          <p>
            방문신청시 발급 받은 QR Code를 인식시켜주세요.
          </p>
          <br/>
          <br/>
          <div class="box-row">

<!--            <StreamBarcodeReader v-if="!isMobile"-->
<!--                                 @decode="onDecode"-->
<!--                                 @loaded="onLoaded"-->
<!--                                 @error="onError">-->
<!--            </StreamBarcodeReader>-->

            <qrcode-stream v-if="!isMobile"
                    @decode="onDecode"
                    :track="paintOutline"
                    @init="onInitPc">
            </qrcode-stream>

            <qrcode-stream v-if="isMobile"
                         :camera="camera"
                         @init="onInit"
                         :track="paintOutline"
                         @decode="onDecode">
<!--                  <button @click="switchCamera"><i class="icon-refresh"></i></button>-->
            </qrcode-stream>
          </div>

        </div>
        <div class="box-bottom">
          <div v-if="isMobile" class="lang" @click="switchCamera"><i class="icon-refresh"></i></div>
          <a @click="goEmployee()" class="btn lg point">임직원</a>
          <router-link to="/manualEnter" class="btn lg white point">수기신청</router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { StreamBarcodeReader } from "vue-barcode-reader";
  import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

  export default {
    name: "Home",
    components: {
      StreamBarcodeReader,
      QrcodeStream
    },
    data(){
      return {
        isShow: true,
        lastUpdateDateTime: null,
        delay: 1000 * 20,
        interval: null,
        qrData: null,

          camera: 'front',
          noRearCamera: false,
          noFrontCamera: false,

        isMobile: false,
      }
    },
    mounted(){
      this.isMobile = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ? true : false;
      this.isShow = true;
      this.init();
      if (screen.width < 768) {
        var mvp = document.getElementById('myViewport');
        mvp.setAttribute('content','width=device-width, initial-scale=1');
      }
    },
    methods: {
      init(){
        this.resetTime();
        var that = this;
        this.interval = setInterval(()=>{
          if(that.checkReset()){
            that.resetPage();
          }
        },that.delay)
        //10초에 한번씩 스캔 데이터 지우기

        this.qrInterval = setInterval(()=>{
          that.qrData = null
        },10000)
      },
      goEmployee(){
        this.$router.push({name: 'employeeRequest'});
      },
      goQrEnter(){
        var uuid = "3ffb420f-4cba-4c11-a868-91de2ad931c4";
        this.scanQr(uuid);
      },
      resetTime(){
        //this.$toast.success('연장되었습니다.');
        this.lastUpdateDateTime = moment().clone();
      },
      resetPage(){
        var that = this;
        clearInterval(this.interval);
        //this.$toast.success('갱신되었습니다.');
        setTimeout(()=>{
          that.$router.go(that.$router.currentRoute);
        },3000)
      },
      checkReset(){
        var current = moment().clone();
        var before = this.lastUpdateDateTime.clone().add(10, 'minutes');
        var result = current.isAfter(before);

        //this.$toast.success('체크되었습니다.' + result);
        return result;
      },
      onDecode(data){
        var that = this;
        this.resetTime();
        //var uuid = "3ffb420f-4cba-4c11-a868-91de2ad931c4";
        //10초내에 동일한 코드로 스캔불가
        if(isNaN(data)){
          if(this.qrData != data) {
            console.log('qrData : ' + this.qrData);
            console.log('data : ' + data)
            this.qrData = data;
            this.scanQr(data)
          }
        }
      },
      scanQr(uuid){

        this.$http.get('/api/private/scanQr/' + uuid)
          .then((result) => {
            this.noti('확인', '스캔되었습니다.', 'success');

            // if(result.data.isApplicant == 0) {
            var steps =  [        //{id: 1, name: this.$t('label.enterTicket'), routeName : 'selectIdc', isSelect: 'on', component: 'SelectTicket'},
              {id: 1, name: this.$t('label.secAgree'), routeName : 'agree', isSelect: '', component: 'Agree'},
              {id: 2, name: this.$t('label.inOutCheckList'), routeName : 'inputInfo', isSelect: '', component: 'InOutCheckList'},
              {id: 3, name: this.$t('label.enterInfo'), routeName : 'checkInfo', isSelect: '', component: 'EnterInfo'},
            ]
            this.openModal({view: 'modal/TosCheck', side: false, mode: 'new' , title: '출입 필수사항 확인 ', data: {steps : steps, data: result.data}, showBottom: false})
            // }else{
            //   this.$toast.success('조회되었습니다.');
            //   this.$router.push({name: 'requestLookup', data: {uuid: uuid}});
            // }
            clearInterval(this.interval);
          }).catch((e) =>{
          debugger;
          this.noti("기간만료", e.response.data.message, 'danger')
          console.log(e);
        })
      },
      onLoaded(data){

      },
      onError(error){
        this.resetTime();
      },
      switchCamera () {
        switch (this.camera) {
          case 'front':
            this.camera = 'rear';
            break
          case 'rear':
            this.camera = 'front';
            break
        }
      },
      async onInitPc (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permission"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          } else if (error.name === 'InsecureContextError') {
            this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
          } else {
            this.error = `ERROR: Camera error (${error.name})`;
          }
        }
      },
      async onInit (promise) {
          try {
              await promise
          } catch (error) {
              const triedFrontCamera = this.camera === 'front'
              const triedRearCamera = this.camera === 'rear'

              const cameraMissingError = error.name === 'OverconstrainedError'

              if (triedRearCamera && cameraMissingError) {
                  this.noRearCamera = true
              }

              if (triedFrontCamera && cameraMissingError) {
                  this.noFrontCamera = true
              }

              console.error(error)
          }
      },
      paintOutline (detectedCodes, ctx) {
          for (const detectedCode of detectedCodes) {
              const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints

              ctx.strokeStyle = "red";

              ctx.beginPath();
              ctx.moveTo(firstPoint.x, firstPoint.y);
              for (const { x, y } of otherPoints) {
                  ctx.lineTo(x, y);
              }
              ctx.lineTo(firstPoint.x, firstPoint.y);
              ctx.closePath();
              ctx.stroke();
          }
      }
    }
  };

  //TODO : 아이패드 해상도 처리
</script>

